import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "default-configuration"
    }}>{`Default configuration`}</h1>
    <h2 {...{
      "id": "setting-defaults-on-filebrowser-component"
    }}>{`Setting defaults on `}<inlineCode parentName="h2">{`FileBrowser`}</inlineCode>{` component`}</h2>
    <p>{`If you look at the `}<a parentName="p" {...{
        "href": "/docs/2.x/api/file-browser"
      }}><inlineCode parentName="a">{`FileBrowser`}</inlineCode>{` API reference`}</a>{`, you will see that
there are many settings you can set on the `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{` component :`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<FileBrowser
    files={[]}
    doubleClickDelay={300}
    disableSelection={true}
    disableDefaultFileActions={true}
>
    {/* ... */}
</FileBrowser>
`}</code></pre>
    <p>{`These settings will only affect this particular file browser instance. Additionally, if
you change any of the props by passing a different value, the file browser will
re-render to reflect the changes.`}</p>
    <p>{`This is convenient if you only have one `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{` in your app, or if want each
individual `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{` to have its own settings.`}</p>
    <h2 {...{
      "id": "setting-global-defaults"
    }}>{`Setting global defaults`}</h2>
    <p>{`If you want to set the global defaults for all file browsers, you can use the
`}<inlineCode parentName="p">{`setChonkyDefaults`}</inlineCode>{` helper method. It lets you define defaults for many (but not all)
file browser props:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { setChonkyDefaults } from 'chonky';
import { ChonkyIconFA } from 'chonky-icon-fontawesome';

setChonkyDefaults({
    iconComponent: ChonkyIconFA,
    disableSelection: true,
    disableDragAndDropProvider: true,
});
`}</code></pre>
    <p>{`Note that `}<inlineCode parentName="p">{`setChonkyDefaults`}</inlineCode>{` should be used somewhere near the root of your
application, before any components are rendered. It is not recommended to call
`}<inlineCode parentName="p">{`setChonkyDefaults`}</inlineCode>{` at runtime, because existing `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{` instances will `}<strong parentName="p">{`not`}</strong>{`
re-render to reflect default config changes.`}</p>
    <p>{`You can set global defaults for the following file browser props:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`export type ChonkyConfig = Pick<
    FileBrowserProps,
    | 'fileActions'
    | 'onFileAction'
    | 'thumbnailGenerator'
    | 'doubleClickDelay'
    | 'disableSelection'
    | 'disableDefaultFileActions'
    | 'disableDragAndDrop'
    | 'disableDragAndDropProvider'
    | 'defaultSortActionId'
    | 'defaultFileViewActionId'
    | 'clearSelectionOnOutsideClick'
    | 'iconComponent'
>;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      